<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="ConfirmLandscapeInvitation"
    title="Landscape invitation"
    submit-name="Accept"
    :cancel-name="landscape ? 'Reject' : 'Close'"
    :submit-disabled="!landscape"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="landscape">
      <p v-if="landscape.inviter" class="text-gray-700">
        <span class="mr-1 font-medium text-gray-900">{{
          landscape.inviter.username
        }}</span
        >has invited you to join:
      </p>
      <div class="mb-8 p-4 text-gray-700 border border-highlightBase">
        <h1 class="mb-2 text-highlight">{{ landscape.name }}</h1>
        <p
          v-if="landscape.description"
          class="mb-0 leading-tight text-gray-700"
        >
          {{ landscape.description }}
        </p>
        <div v-if="landscape.inviter" class="flex items-center mt-3">
          <lm-avatar :src="landscape.inviter.picture" />
          <div class="flex flex-col ml-2 ">
            <h1 class="text-gray-700 font-sans truncate">
              {{ landscape.inviter.username }}
            </h1>
            <span class="mt-1 ml-px text-xs text-gray-500 font-sans truncate">{{
              landscape.inviter.role
            }}</span>
          </div>
        </div>
      </div>
      <lm-legal-checkbox ref="legal" v-model="checkLegal" type="user" />
    </template>
  </form-modal>
</template>

<script>
import LmLegalCheckbox from '@/components/form/LmLegalCheckbox'
import LmAvatar from '@/components/ui/LmAvatar'
import {mapGetters} from 'vuex'
import {Events, Modal, AlertMessages} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ConfirmLandscapeInvitation',
  components: {LmAvatar, LmLegalCheckbox, FormModal},
  data() {
    return {
      Events,
      modalName: Modal.CONFIRM_LANDSCAPE,
      checkLegal: false
    }
  },
  computed: {
    ...mapGetters({landscape: 'tempLandscapeInvitation'})
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    submit() {
      if (this.$refs.legal.validateData()) {
        this.$store
          .dispatch('acceptInvitation', this.landscape._id)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit, fromClose}) {
      if (fromSubmit) {
        const msg = `${AlertMessages.CONFIRM_LANDSCAPE} ${this.landscape.name}`
        EventHub.emit(Events.SHOW_SNACKBAR, msg)
        this.$router.push({
          name: 'info',
          params: {landscapeSlug: this.landscape.slug}
        })
      } else if (fromClose) {
        this.$store.dispatch('rejectInvitation', this.landscape._id)
        const msg = `${AlertMessages.REJECT_LANDSCAPE} ${this.landscape.name}`
        EventHub.emit(Events.SHOW_SNACKBAR, msg)
      }
      this.$store.commit('removeTempLandscapeInvitation')
    }
  }
}
</script>

<style>
@media (--desktop) {
  .ConfirmLandscapeInvitation .Modal-wrapper {
    width: 480px;
    .Modal-body {
      height: 320px;
    }
  }
}
</style>
